/* eslint-disable sonarjs/no-duplicate-string */
import colors from './colors';
import blue from '../colors/blue';
import purple from '../colors/purple';
import gray from '../colors/gray';
import red from '../colors/red';
import yellow from '../colors/yellow';
import green from '../colors/green';
import spacing from '../TCP/spacing';
import colorPalette from './colorPalette';
import { FONT_SIZES } from '../typography.constants';
import { FONTS } from '../TCP/fonts';

export default {
  APPLE_PAY_BUTTON_BORDER_RADIUS: spacing.ELEM_SPACING.XXS,
  BACK_TO_TOP_BORDER_COLOR: purple['900'],
  BUTTON_CURVE_CSS: ``,
  BUTTON_NO_CURVE_MOBILE_CSS: ``,
  BUTTON_HOVER_BORDER_BOTTOM_COLOR: colors.ANCHOR.SECONDARY,
  BUTTON_SHADOW_PRIMARY_COLOR: colors.PRIMARY.COLOR1,
  BUTTON_SHADOW_SECONDARY_COLOR: colors.PRIMARY.COLOR1,
  CART_ITEM_TILE_IMAGE_BRAND_WIDTH: '62px',
  CART_ITEM_TILE_IMAGE_BRAND_HEIGHT: '22px',
  CTA_LINK_LIST_FONT_WEIGHT: ``,
  PRODUCT_INFO_IMAGE_BRAND_HEIGHT: '22px',
  PROMO_BADGE_BACKGROUND_COLOR: purple['900'],
  PROMO_BADGE_BORDER_RADIUS: '5px',
  SPINNER_COLOR: purple['900'],
  OUTFIT_PRODUCT_OFFER_PRICE_COLOR: red['500'],
  BACKGROUND_HOVER_L2: purple['100'],
  NAV_CATEGORY_HEADING: purple['50'],
  STROKE_COLOR_BORDER_COLOR: purple['700'],
  FOOTER_SOCIAL_ICONS_DESKTOP_WIDTH: '48px',
  FOOTER_SOCIAL_ICONS_DESKTOP_HEIGHT: '48px',
  FOOTER_SOCIAL_ICONS_MOBILE_WIDTH: '36px',
  FOOTER_SOCIAL_ICONS_MOBILE_HEIGHT: '36px',
  ORDER_HISTORY_BACKGROUND_COLOR: purple['50'],
  JOIN_OUR_TEXT_ALERTS_FONT: 'UrbaneRounded-DemiBold',
  REFER_A_FRIEND_FONT: 'UrbaneRounded-DemiBold',
  REFER_A_FRIEND_COLOR: purple['800'],
  THREE_BRANDS_ONE_PLACE: 'UrbaneRounded,Arial, Helvetica, sans-serif',
  BRAND_SPECIFIC_FONT: 'UrbaneRounded,Arial, Helvetica, sans-serif',
  EXTENDED_PREORDER_COLOR: green['500'],

  MODULE_A: {
    BANNER_SLIDE_MAX_HEIGHT: '311px',
    BANNER_SLIDE_MAX_HEIGHT_FOR_MEDIUM: '406px',
    CTA_LIST_COLOR: (fill) => colors.BUTTON[fill || 'WHITE'].TEXT,
    CTA_LIST_FONT_WEIGHT: '',
  },
  MODULE_D: {
    IMAGE_CTA_LIST_COLOR: colors.BUTTON.WHITE.TEXT,
    IMAGE_CTA_LIST_FONT_WEIGHT: '',
  },
  MODULE_N: {
    PERCENTAGE_INLINE_PROMO_FONT_SIZE: '',
  },
  PRODUCT_LISTING_BRAND_SPECIFIC_COLOR: blue.D100,
  MODULE_G: {
    PRODUCT_TAB_LISTING_MARGIN_TOP: '10px',
    PROMO_CONTAINER_MARGIN_TOP: spacing.ELEM_SPACING.XXS,
    WRAPPER_MARGIN_BOTTOM: '10px',
  },
  MODULE_O: {
    LIST_PRICE_COLOR: red['500'],
  },
  MODULE_T: {
    BTN_LIST_COLOR: colorPalette.text.primary,
    BUTTON_LIST_CONTAINER: `
      .image-comp {
        color: ${colorPalette.black};
      }
    `,
  },
  TEXT_STYLE_FONT_SIZE: {
    SPACED_TEXT: FONT_SIZES.fs22,
    MEDIUM_TEXT: FONT_SIZES.fs14,
    MEDIUM_TEXT_LARGE_MEDIA_QUERY: FONT_SIZES.fs20,
  },
  VENMO_PAYMENT_BUTTON_BORDER_RADIUS: spacing.ELEM_SPACING.XXS,
  CART_ITEM_COUNT_BACKGROUND_COLOR: colorPalette.primary.dark,
  FOOTER_NAV_HEADER_BACKGROUND_COLOR: colorPalette.primary.main,
  PDP_PRICE_COLOR: gray['900'],
  L2_HOVER: purple[800],
  L2_BG_COLOR: `linear-gradient(to right, #89f1f4 0%, #89d0fd 10%, #8db8ff 20%, #95a2ff 30%, #9f8dff 40%, #b984ff 50%, #d985f2 60%, #fa90d4 70%, #ff9cba 80%, #ffaca2 90%, #ffc58b 100%)`,
  L2_MOBILE_BG_COLOR: `linear-gradient(to right, #89f1f4 0%, #89d0fd 10%, #8db8ff 20%, #95a2ff 30%, #9f8dff 40%, #b984ff 50%, #d985f2 60%, #fa90d4 70%, #ff9cba 80%, #ffaca2 90%, #ffc58b 100%)`,
  EMAIL_SIGNUP_BTN: yellow[800],
  ADDRESS_CAROUSEL_SELECTED_ELEM: {
    PADDING: '5px 15px 7px 15px',
  },
  STORE_LOCATOR_BACKGROUND: purple['50'],
  BORDER_BOTTOM_FOR_EARN_EXTRA_POINTS: gray['900'],
  PRODUCT_ADD_TO_BAG: {
    SOCIAL_PROOF_DESKTOP_BOTTOM_PADDING_TOP: '6px',
    SOCIAL_PROOF_DESKTOP_BOTTOM_MARGIN: '0px 6px',
    BUTTON_BGCOLOR: colorPalette.blue.C900,
  },
  HEADER_TOP_NAV: {
    HEADER_OPTION_RIGHT: '0px',
  },
  COMPLETE_THE_LOOK_STYLE: {
    COMPLETE_THE_LOOK_NEW_PDP_BORDER: purple[700],
  },
  MODULE_Q_COMPLETE_THE_LOOK: {
    VIEW_LOOK_TEXT_COLOR: gray[900],
  },
  SIGNUP_CONFIRM: {
    CONFIRM_SMILEY_LOGO_WRAPPER_PADDING: '10px 0 10px 0',
    CONFIRMATION_LABEL_BACKGROUND: colors.TEXT.DARKERBLUE,
  },
  EMAIL_SIGNUP_FORM: {
    FIELD_CONTAINER_PADDING_TOP: '0px',
    LOGO_WRAPPER_PADDING: '10px 0 10px 0',
    TERMS_CONTAINER_MARGIN: '42px auto 20px',
  },
  SMS_SIGNUP_FORM: {
    LOGO_WRAPPER_PADDING: '10px 0 10px 0',
    TERMS_CONTAINER_MARGIN_TOP: '20px',
  },
  SOCIAL_PROOF_MESSAGE: {
    STYLED_SOCIAL_PROOF_TEXT_BACKGROUND_COLOR: purple[50],
    STYLED_SOCIAL_PROOF_TEXT_BACKGROUND_COLOR_MOBILE: purple[50],
  },
  HEADER_STYLES: {
    TITLE_TEXT_FONT_FAMILY: 'Urbane Rounded',
    WELCOME_TEXT_STYLES_FONT_FAMILY: 'UrbaneRounded-Light',
    TITLE_TEXT_STYLES_FONT_FAMILY: 'UrbaneRounded-Medium',
  },
  HEADER_NEW_STYLES: {
    GET_ADDITIONAL_TITLE_TEXT_STYLES: 'UrbaneRounded-Medium',
    TITLE_TEXT_COUNT: '',
  },
  HOME_PAGE: {
    SET_BACKGROUND: `background-color: ${purple[300]};`,
  },
  SMS_SIGNUP_MODAL: {
    SIGN_UP_MODAL_CONFIRM_VIEW_MARGIN_TOP: '20px',
    SIGN_UP_MODAL_CONFIRM_VIEW_MARGIN_BOTTOM: '20px',
    DESC_TEXT_FONT_SIZE: FONT_SIZES.fs16,
    DESC_TEXT_WIDTH_HEIGHT: `width: 192px;
                            margin: 20px auto;`,
    SMS_SIGNUP_MODAL_MARGIN_TOP: '20px',
  },
  FOOTER: {
    FOOTER_TOP_CANDIDATE_COLOR: colors.TEXT.DARKGRAY,
    FOOTER_TOP_CANDIDATE_A_SOCIAL_LINKS_FLEX_DIRECTION: 'column',
    FOOTER_TOP_CANDIDATE_A_SOCIAL_LINKS_PADDING: '0px',
    FOOTER_TOP_CANDIDATE_A_SOCIAL_LINKS_FLEX_DIRECTION_MOBILE: 'row',
  },
  COUNTRY_SELECTOR: {
    DISPLAY: 'none',
    COUNTRY_SELECTOR_DISPLAY: 'none',
  },
  ACCESSORY_SELECTED_BORDER_COLOR: purple[700],

  VENMO_BUTTON_OVERLAY: {
    VENMO_OVERLAY_BUTTON_BORDER_RADIUS: spacing.ELEM_SPACING.XXS,
  },
  COMBINED_CONFIRM: {
    CONFIRMATION_LABEL_BACKGROUND: colors.TEXT.DARKERBLUE,
  },
  COMBINED_FORM_INTRO: {
    OFFER_TYPE_LABEL_FONT_SIZE: '30px',
    OFFER_TYPE_LABEL_BACKGROUND: colors.TEXT.DARKERBLUE,
  },
  DROPDOWN_LIST: {
    DROPDOWN_ACTIVE_CLASS_BACKGROUND_COLOR: blue[50],
    UL_BORDER_WITH_LAST_ROW: blue[50],
  },
  PLCC_OFFER_INTRO: {
    PLCC_OFFER_TYPE_LABEL_BACKGROUND: colors.TEXT.DARKERBLUE,
  },
  SIGNUP_FORM_INTRO: {
    OFFER_TYPE_LABEL_FONT_SIZE: '38px',
    OFFER_TYPE_LABEL_BACKGROUND: colors.TEXT.DARKERBLUE,
  },
  PICKUP_PRODUCT_FORM_PART: {
    LIST_PRICE_COLOR: red[600],
    ACTUAL_PRICE_COLOR: red[500],
  },
  PICKUP_STORE_MODAL: {
    ACTUAL_PRICE_COLOR: red[500],
    PRODUCT_PRICE_CONTAINER_ACTUAL_PRICE_COLOR: red[500],
  },
  PRODUCT_CUSTOMIZE_FORM_PART: {
    PRODUCT_DETAILS_CARD_CONTAINER_ACTUAL_PRICE_COLOR: red[500],
    PRICE_CONTAINER_ACTUAL_PRICE_COLOR: red[500],
  },
  BOPIS_FILTER_EMPTY_RESULTS: {
    BOPIS_FILTER_EMPTY_RESULTS_VIEW_BACKGROUND_COLOR: blue[1000],
  },
  EMPTY_CATEGORY_BANNER: {
    INTERIM_SOLD_OUT_BACKGROUND_COLOR: blue[1000],
  },
  ADDED_TO_BAG_ACTIONS: {
    CHECKOUT_GYM: '',
    CHECKOUT: '',
  },
  BAG_PAGE_STYLES: {
    BORDER_RADIUS: '',
  },
  MODULE_S_STYLES: {
    STYLED_LINK_TEXT_COLOR: colors.WHITE,
    HEADER_TEXT_MARGIN_BOTTOM: 'display: inline-block;line-height: 0.94;letter-spacing: normal;',
    COL_IMG_WRAPPER_HEIGHT: '356px',
    COL_IMG_WRAPPER_HEIGHT_MEDIUM_ONLY: '356px',
    COL_IMG_WRAPPER_HEIGHT_LARGE: '580px',
    IMAGE_CONTAINER_HEIGHT: '356px',
    GET_RIGHT_VALUE: '25px',
    GET_LEFT_VALUE: '25px',
    CONTAINER_WIDTH: '259px',
  },
  HOME_PAGE_STYLE: {
    SET_BACKGROUND: purple['300'],
  },
  MENU_ITEMS: {
    PROMO_CONTAINER_BR: '5px',
  },
  NAV_MENU_LEVEL_ONE: {
    L1_TEXT_VIEW_WIDTH: '50%',
    L1_TEXT_VIEW_TOP: '50%',
  },
  FOOTER_TOP_CANDIDATE_SOCIAL_MARGIN: '',
  CODE_PUSH_ANIMATION_STYLES: FONTS.urbaneRounded,
  MULTI_PRODUCT_ADD_TO_BAG: purple['300'],
  USER_ONBOARING_SCREEN_BGCOLOR: 'transparent',
  RECOM_QVMODAL_BUTTON: {
    BGCOLOR: colors.PRIMARY.DARKBLUE,
  },
  KEEP_SHOPPING_TEXT: {
    COLOR: colors.BLACK,
  },
  STICKY_ATB_BUTTON: {
    COLOR: colors.WHITE,
    BGCOLOR: blue[900],
  },
  DELIVERY_METHOD_PRIMARY_LABEL_COLOR: gray['900'],
  DELIVERY_METHOD_SECONDARY_LABEL_COLOR: green['500'],
  DELIVERY_METHOD_BORDER_COLOR: purple[900],
  HORIZONTAL_PLP: {
    COLOR: colors.WHITE,
    BGCOLOR: colorPalette.blue.C900,
  },
  PRODUCTS_GRID_ITEM: {
    BUTTON_BGCOLOR: colorPalette.blue.C900,
  },
  BRAND_BASED_BUTTON_HOVER: '#1C2E40',
  BRAND_BASED_BUTTON_FOCUS: '#2A4760',
  PDP_ACTIVE_TAB_COLOR: purple['900'],
  TTJ_BUTTON_TEXT_COLOR: colors.BLACK,
};
